import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { createApiWithPath } from "../../api/client";
import { ConnectionFeedback } from "../../api/types/people-connection";
import "./Confirmation.css";

export default function CheckInResponse() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [responseValue, setResponseValue] = useState<string | null>(null);

  useEffect(() => {
    const submitResponse = async () => {
      const value = searchParams.get("value");

      if (!id || !value) {
        setError("Invalid link");
        setLoading(false);
        return;
      }

      try {
        await createApiWithPath("v1/connection").post(`/item/${id}/check-in`, {
          value,
        });
        setResponseValue(value);
      } catch (err: any) {
        setError(
          err.response?.data?.message || "Failed to process your response",
        );
      } finally {
        setLoading(false);
      }
    };

    submitResponse();
  }, [id, searchParams]);

  if (loading) {
    return (
      <div className="connection-confirmation">
        <div className="confirmation-card">
          <div className="loading">Processing...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="connection-confirmation">
        <div className="confirmation-card error">
          <h2>⚠️ Error</h2>
          <p>{error}</p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  const getMessage = () => {
    switch (responseValue) {
      case ConnectionFeedback.YES:
        return {
          title: "Thank you!",
          message:
            "We're glad you connected! You should receive a feedback form email shortly.",
          icon: "✓",
        };
      case ConnectionFeedback.NO:
        return {
          title: "Thank you for your feedback",
          message:
            "We appreciate your honesty. We'll work on finding a better match for you.",
          icon: "ℹ",
        };
      case ConnectionFeedback.SCHEDULED:
        return {
          title: "Great!",
          message: "We'll check back with you later.",
          icon: "ℹ",
        };
      default:
        return {
          title: "Thank you!",
          message: "Your response has been recorded.",
          icon: "✓",
        };
    }
  };

  const { title, message, icon } = getMessage();

  return (
    <div className="connection-confirmation">
      <div className="confirmation-card">
        <div className="status-icon approved">{icon}</div>

        <h2>{title}</h2>

        <div className="details">
          <p className="note">{message}</p>
        </div>

        <footer>
          <p>Harpier Team</p>
          <p className="text-sm">Building meaningful connections</p>
        </footer>
      </div>
    </div>
  );
}
